// extracted by mini-css-extract-plugin
export default {"brand":"BrandAvatar_brand__pdgYZ","avatar":"BrandAvatar_avatar__6CmTL","name":"BrandAvatar_name__Klg38","nameLarge":"BrandAvatar_nameLarge__3YGRh"};